(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-ofertas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.mdOfertasCarrito) return;
    window.mdOfertasCarrito = true;
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function actualizarContadores(cantidad) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not(.visually-hidden)').forEach(function (el) {
        el.textContent = cantidad;
      });
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sourceId: 'md-ofertas', data: { source: 'md-ofertas', itemCount: cantidad } } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    function refrescarIcono() {
      var icono = document.getElementById('cart-icon-bubble');
      if (!icono) return Promise.resolve();
      return fetch(raiz + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-icon-bubble'];
          if (!html) return;
          var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (nuevo) icono.innerHTML = nuevo.innerHTML;
        });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.md-oferta__form');
      if (!form) return;
      e.preventDefault();
      var boton = form.querySelector('[type="submit"]');
      var error = form.querySelector('.md-oferta__error');
      var texto = boton.textContent;
      var carro = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var datos = new FormData(form);
      if (carro && typeof carro.getSectionsToRender === 'function') {
        datos.append('sections', carro.getSectionsToRender().map(function (s) { return s.id; }));
        datos.append('sections_url', window.location.pathname);
        if (typeof carro.setActiveElement === 'function') carro.setActiveElement(document.activeElement);
      }
      boton.disabled = true;
      boton.textContent = 'Agregando…';
      if (error) error.hidden = true;

      fetch(raiz + 'cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: datos })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'No se pudo agregar');
          if (carro && typeof carro.renderContents === 'function') {
            if (carro.classList.contains('is-empty')) carro.classList.remove('is-empty');
            carro.renderContents(res);
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'md-ofertas', productVariantId: datos.get('id'), cartData: res });
          }
          return fetch(raiz + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            actualizarContadores(cart.item_count);
            if (!carro) return refrescarIcono();
          });
        })
        .then(function () {
          boton.textContent = 'Agregado ✓';
          setTimeout(function () { boton.textContent = texto; }, 1500);
        })
        .catch(function (err) {
          boton.textContent = texto;
          if (error) { error.textContent = err.message; error.hidden = false; }
        })
        .finally(function () { boton.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
